"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  chooseAnOption: 'Choose an option',
  email: 'Email',
  enterTelephoneNumber: 'Enter telephone number',
  enterYourEmail: 'Enter your email below to be notified when this item is back on stock.',
  invalidEmail: 'Email address is not valid.',
  invalidTelephoneNumber: 'Telephone number is not valid.',
  notifyMe: 'Notify me when the product becomes available',
  notifyMeSuccess: 'You will get an {0} when this product is back in stock!',
  pleaseTryAgainLater: 'Please try again later.',
  requestFailed: 'Request failed.',
  sms: 'SMS',
  submitNotification: 'Notify me',
  thankYou: 'Thank you!'
};
const translationsNamespace = exports.translationsNamespace = 'back-in-stock-notification';
